export const TAG_CLASS = 'bb_tag';
export const TAG_CLOSE_CLASS = `${TAG_CLASS}__close`;
export const TAG_CLOSE_TESTID = 'tag-close';
